import * as React from 'react';
import { Body2, Button, UIHeading2, UIHeading4 } from '@cian/ui-kit';
import { IconCommunicationMessage16 } from '@cian/ui-kit-design-tokens/icons';

import { INewbuildingSummaryCell } from '../../../../../../types/newbuildingsCompare';
import { Link } from '../../../../../Link';
import { Photo } from './parts/Photo';
import { Rating } from './parts/Rating';
import * as style from './NewbuildingSummaryCell.css';

export interface INewbuildingSummaryCellProps {
  cell: INewbuildingSummaryCell;
}

export const NewbuildingSummaryCell = ({ cell }: INewbuildingSummaryCellProps): React.JSX.Element => {
  const { data, state } = cell;

  if (!data) {
    return <Body2>{state.text ?? ''}</Body2>;
  }

  const { name, fullUrl, imageUrl, isFavorite, priceRange, reviews, builders, sellers } = data;
  const hasChat = [...builders, ...sellers].some(contact => contact.chat?.enabled);

  return (
    <div className={style['container']}>
      <Photo imageUrl={imageUrl} isFavorite={isFavorite} name={name} />
      <div className={style['info']}>
        <div className={style['price-facts']}>
          <div className={style['name']}>
            <Link href={fullUrl} target="_blank">
              <UIHeading2 color="text-main-default">{name}</UIHeading2>
            </Link>
          </div>
          <div className={style['facts']}>
            {priceRange && <UIHeading4>{priceRange}</UIHeading4>}
            <Rating countText={reviews.countText} rating={reviews.rating} />
          </div>
        </div>
        <div className={style['buttons']}>
          {/* TODO: показать телефон */}
          <Button size="M" theme="main_primary">
            Показать телефон
          </Button>
          {hasChat && (
            // TODO: открыть чат
            <Button
              beforeIcon={<IconCommunicationMessage16 color="current_color" />}
              size="M"
              theme="main_primary"
              title="Написать сообщение"
            />
          )}
        </div>
      </div>
    </div>
  );
};
